import AnalyticsPageShell from '../components/analytics/AnalyticsPageShell';
import { useAdminAnalyticsHierarchyContext } from '../contexts/AdminAnalyticsHierarchyContext';

function AdminAnalyticsPage() {
  const hierarchy = useAdminAnalyticsHierarchyContext();
  return (
    <AnalyticsPageShell
      hierarchy={hierarchy}
      renderMonitorName="AdminAnalyticsPage"
      overviewCacheNamespace="admin-analytics"
    />
  );
}

export default AdminAnalyticsPage;
